import axios from 'axios'

export const state = {
  addressTypes: {},
  addresses: {},
}

export const getters = {
  listAddressTypes (state) {
    return state.addressTypes
  },
  listAddresses (state) {
    return state.addresses
  },
}

export const mutations = {
  SET_ADDRESS_TYPES (state, addressTypes) {
    state.addressTypes = addressTypes
  },
  SET_ADDRESSES (state, addresses) {
    state.addresses = addresses
  },
}

export const actions = {
  getListAddressTypes({ commit }, params = {}) {
    return axios.get('/address_types/search', { params })
  },
  getAddressTypes({ commit }, params = {
    limit: 500,
  }) {
    return axios.get('/address_types/search', { params }).then(({ data }) => {
      return commit('SET_ADDRESS_TYPES', data)
    })
  },
  getAddresses({ commit }, params = {
    limit: 500,
  }) {
    return axios.get('/addresses', { params }).then(({ data }) => {
      return commit('SET_ADDRESSES', data)
    })
  },
  createAddressTypes({ commit }, data) {
    return axios.post('/address_types', data)
  },
  getAddressType({ commit }, data) {
    return axios.get(`/address_types/${data.id}`, data)
  },
  updateAddressTypes({ commit }, data) {
    return axios.put(`/address_types/${data.id}`, data)
  },
  deleteAddressTypes({ commit }, id) {
    return axios.delete(`/address_types/${id}`)
  },
}
